import { styled } from '@linaria/react'
import { PopupHeaderSC } from 'blocks/Popup/Popup.styled'
import { COLOR } from 'vars/index'
import { SidebarComponentSC } from '../SidebarComponent.styled'
import { EpgSidebarBodySC } from '../Templates/EpgSidebarTemplate.styled'
import { EpgPosterSC } from './EpgPoster.styled'

export const TextBoxSkeletonSC = styled.div<{ height: string; width: string }>`
  background-color: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
  height: ${({ height }) => `var(${height})`};
  width: ${({ width }) => `var(${width})`};
`

export const EpgSidebarHeaderSkeletonSC = styled(PopupHeaderSC)``
export const EpgSidebarBodySkeletonSC = styled(EpgSidebarBodySC)`
  ${TextBoxSkeletonSC} {
    margin: 0 calc(var(--paddingRight) - var(--scrollbarOffset));
  }
`
export const SidebarSkeletonSC = styled(SidebarComponentSC)``
export const LogoSkeletonSC = styled(EpgPosterSC)``
